import { FirmUser } from '../types/FirmType';
import { OrganisationContact } from '../types/OrganisationType';

export function getFullName(user: PublicUser | FirmUser | undefined) {
  if (!user) {
    return '';
  }
  return user.givenName + ' ' + user.familyName;
}

export function getFullContactName(contact: OrganisationContact | undefined) {
  if (!contact) {
    return '';
  }
  return contact.firstName + ' ' + contact.lastName;
}
